import { NgModule } from '@angular/core';

import { StepWizardComponent } from './step-wizard.component';
import { StepWizardTitleDirective } from './directives/step-wizard-title.directive';
import { StepWizardStepDirective } from './directives/step-wizard-step.directive';
import { StepWizardStepSideDirective } from './directives/step-wizard-step-side.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { StepWizardStepperComponent } from './components/stepper/step-wizard-stepper.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { SharedDirectivesModule } from '../../shared-directives.module';

@NgModule({
  declarations: [
    StepWizardComponent,
    StepWizardTitleDirective,
    StepWizardStepDirective,
    StepWizardStepSideDirective,
    StepWizardStepperComponent,
  ],
  exports: [StepWizardComponent, StepWizardTitleDirective, StepWizardStepDirective, StepWizardStepSideDirective],
  imports: [CommonModule, TranslateModule, NzButtonModule, SharedDirectivesModule],
})
export class StepWizardModule {}
